import { elapsed, ONE_SECOND, relativeNow } from '@datadog/browser-core'; // Maximum duration for click actions

export var CLICK_ACTION_MAX_DURATION = 10 * ONE_SECOND;
export var interactionSelectorCache = new Map();
export function getInteractionSelector(relativeTimestamp) {
  var selector = interactionSelectorCache.get(relativeTimestamp);
  interactionSelectorCache["delete"](relativeTimestamp);
  return selector;
}
export function updateInteractionSelector(relativeTimestamp, selector) {
  interactionSelectorCache.set(relativeTimestamp, selector);
  interactionSelectorCache.forEach(function (_, relativeTimestamp) {
    if (elapsed(relativeTimestamp, relativeNow()) > CLICK_ACTION_MAX_DURATION) {
      interactionSelectorCache["delete"](relativeTimestamp);
    }
  });
}